import React from "react"
import { Redirect } from "react-router-dom"
// Dashboard
import Dashboard from "../features/Menu/index"

// Authentication related pages
import Login from "../features/Authentication/Login"
import Logout from "../features/Authentication/Logout"
import Register from "../features/Authentication/Register"

//Catalogos
import { AddInfoToTest } from "../components/Common/AddInfoToTest"
import { Notifications } from "../components/Common/Notifications"
import { DevPageView } from '../development'
import { CatalogLayoutCategoriesQuiz } from "../features/Catalogs/CategoriesQuiz/CatalogLayoutCategoriesQuiz"
import { CatalogLayoutConceptQuiz } from "../features/Catalogs/ConceptQuiz/CatalogLayoutConceptQuiz"
import { CatalogLayoutCoordination } from "../features/Catalogs/Coordination/CatalogLayoutCoordination"
import CatalogLayoutCustomers from "../features/Catalogs/Customers/CatalogLayoutCustomers"
import { CatalogLayoutEmaNorm } from "../features/Catalogs/EmaNorm/CatalogLayoutEmaNorm"
import { CatalogLayoutEssaysState } from "../features/Catalogs/EssaysState/CatalogLayoutEssaysState"
import CatalogLayoutKinds from "../features/Catalogs/Kinds/CatalogLayoutKinds"
import CatalogLayoutLabArea from "../features/Catalogs/LaboratoryAreas/CatalogLayoutLabArea"
import CatalogLayoutLabCitecMovil from "../features/Catalogs/LaboratoryCitecMovil/CatalogLayoutLabCitecMovil"
import { CatalogLayoutEssays } from "../features/Catalogs/LaboratoryEssays/CatalogLayoutEssays"
import { CatalogLayoutLabSegment } from "../features/Catalogs/LaboratorySegments/CatalogLayoutLabSegment"
import CatalogLayoutLabType from "../features/Catalogs/LaboratoryTypes/CatalogLayoutLabType"
import { CatalogLayoutLocations } from "../features/Catalogs/Locations/CatalogLayoutLocations"
import MenuCatalogos from "../features/Catalogs/Menu/index"
import { CatalogLayoutNormativeTypes } from "../features/Catalogs/NormativeTypes/CatalogLayoutNormativeTypes"
import { CatalogLayoutNorms } from "../features/Catalogs/Norms/CatalogLayoutNorms"
import { CatalogLayoutProducts } from "../features/Catalogs/Products/CatalogLayoutProducts"
import { CatalogLayoutProviders } from "../features/Catalogs/Providers/CatalogLayoutProviders"
import QuotationCatalog from "../features/Catalogs/Quotations/QuotationCatalog"
import { CatalogLayoutRegions } from "../features/Catalogs/Regions/CatalogLayoutRegions"
import CatalogLayoutUnitMeasures from "../features/Catalogs/UnitMeasures/CatalogLayoutUnitMeasures"
import { CatalogLayoutServiceTypes } from "../features/Catalogs/ServiceTypes/CatalogLayoutServiceTypes"
import { CatalogLayoutDefaultAssignments } from "../features/Catalogs/DefaultAssignments/CatalogLayoutDefaultAssignments"
import { CatalogLayoutLabStaffs } from "../features/Catalogs/UserPlatform/CatalogLayoutLabStaffs"
import LabCitec from "../features/LabCitec/LabCitec"
import { LabCitecScheduledTests } from "../features/LabCitec/LabCitecScheduledTests"
import { ProcessNotification } from "../features/LabCitec/ProcessNotification"
import { QuotationsPrint } from "../features/LabCitec/Quotations/quotationsPrint"
import { ExcelReport } from "../features/LabCitec/Requests/Excel/index"
import LabCitecDetails from "../features/LabCitec/Requests/LabCitecDetails"
import { NormLibrary } from "../features/NormLibrary/NormLibrary"
import { NormLibraryPDFViewer } from "../features/NormLibrary/NormLibraryPDFViewer"
import { LabTests } from "../features/ROI/LabTests"
import { Roi } from "../features/ROI/Roi"
import { RoiSummary } from "../features/ROI/RoiSummary"
import { Results } from "../features/Results/Results"
import { ResultsSummary } from "../features/Results/ResultsSummary"
import { LabRequestSamplePrintView } from '../features/lab-request-samples/views/LabRequestSamplePrintView'
import { LabRequestSampleView } from '../features/lab-request-samples/views/LabRequestSampleView'
import { staticRoutes } from './staticRoutes'

// *** This is the route for the development view
const staticDevelopmentView = staticRoutes.developmentView;
const developmentViewRoutes = [
  { path: staticDevelopmentView.base, exact: false, component: DevPageView, name: 'devPageView', title: 'Pantalla de Desarrollo'},
];
// *** This is the route for the development view

// *** This is the route for the lab request samples
const staticLabRequestSamples = staticRoutes.labRequestSamples;
const labRequestSampleRoutes = [
  { path: staticLabRequestSamples.base, exact: false, component: LabRequestSampleView, name: 'labRequestSampleView', title: 'Registro de Muestras'},
  { path: `${staticLabRequestSamples.printView}/:id`, exact: false, component: LabRequestSamplePrintView, name: 'labRequestSamplePrintView', title: 'Registro de Muestras Vista Impresión'},
];
// *** This is the route for the lab request samples

const userRoutes = [
  { path: "/home", component: Dashboard, name: 'home', title: 'Inicio' },
  // Catalogs
  { path: "/catalogs/menu",exact: true, component: MenuCatalogos, name: 'catalogsmenu', title: 'Menú Catálogos'},

  { path: "/catalogs/catalog/laboratory-types",exact: false, component: CatalogLayoutLabType, name: 'labTypeCatalog', title: 'Tipo de Laboratorio'}, 

  { path: "/catalogs/catalog/laboratory-areas",exact: false, component: CatalogLayoutLabArea, name: 'labAreaCatalog', title: 'Área Laboratorio'}, 
  
  { path: "/catalogs/catalog/products",exact: false, component: CatalogLayoutProducts, name: 'ProductsCatalog', title: 'Productos'}, 

  { path: "/catalogs/catalog/laboratory-essays",exact: false, component: CatalogLayoutEssays, name: 'EssaysCatalog', title: 'Ensayos Citec-Móvil'}, 
  
  { path: "/catalogs/catalog/laboratory-segments",exact: false, component: CatalogLayoutLabSegment, name: 'SegmentCatalog', title: 'Segmento de laboratorio'}, 

  { path: "/catalogs/catalog/coordinations",exact: false, component: CatalogLayoutCoordination, name: 'CoordinationCatalog', title: 'Coordinación'}, 

  { path: "/catalogs/catalog/service-types",exact: false, component: CatalogLayoutServiceTypes, name: 'ServiceTypesCatalog', title: 'Tipo de Servicio'}, 

  { path: "/catalogs/catalog/default-assignments",exact: false, component: CatalogLayoutDefaultAssignments, name: 'DefaultAssignmentsCatalog', title: 'Asignaciones Automáticas'}, 

  { path: "/catalogs/catalog/unit-measures",exact: false, component: CatalogLayoutUnitMeasures, name: 'MesureUnitCatalog', title: 'Unidad de medida'}, 

  { path: "/catalogs/catalog/customers",exact: false, component: CatalogLayoutCustomers, name: 'CustomersCatalog', title: 'Clientes'}, 

  { path: "/catalogs/catalog/kinds",exact: false, component: CatalogLayoutKinds, name: 'KindsCatalog', title: 'Clase'}, 
  
  { path: "/catalogs/catalog/laboratory-staffs",exact: false, component: CatalogLayoutLabStaffs, name: 'LabStaffsCatalog', title: 'Usuario de la plataforma'}, 

  { path: "/catalogs/catalog/regions",exact: false, component: CatalogLayoutRegions, name: 'RegionsCatalog', title: 'Localidad'}, 

  { path: "/catalogs/catalog/normative-types",exact: false, component: CatalogLayoutNormativeTypes, name: 'NormativeTypesCatalog', title: 'Tipo de normativa'}, 

  { path: "/catalogs/catalog/locations",exact: false, component: CatalogLayoutLocations, name: 'LocationsCatalog', title: 'Región'}, 

  { path: "/catalogs/catalog/state-essays",exact: false, component: CatalogLayoutEssaysState, name: 'EssaysStateCatalog', title: 'Estado de la muestra'},
  
  { path: "/catalogs/catalog/norms",exact: false, component: CatalogLayoutNorms, name: 'NormsCatalog', title: 'Normas'},
  
  { path: "/catalogs/catalog/providers",exact: false, component: CatalogLayoutProviders, name: 'ProvidersCatalog', title: 'Proveedores'}, 
  
  { path: "/catalogs/catalog/survey_categories",exact: false, component: CatalogLayoutCategoriesQuiz, name: 'CategoriesQuizCatalog', title: 'Categorías de encuesta de satisfacción'}, 
  
  { path: "/catalogs/catalog/survey_concepts",exact: false, component: CatalogLayoutConceptQuiz, name: 'ConceptQuizCatalog', title: 'Conceptos de encuesta de satisfacción'}, 

  { path: "/catalogs/catalog/ema-regulations",exact: false, component: CatalogLayoutEmaNorm, name: 'EmaNormCatalog', title: 'Normativa ema'}, 

  { path: "/catalogs/catalog/laboratories",exact: false, component: CatalogLayoutLabCitecMovil, name: 'LabCitecMovil', title: 'Laboratorios Citec / Móvil'}, 

  { path: "/catalogs/catalog/quotations",exact: false, component: QuotationCatalog, name: 'Quotation', title: 'Notas de Cotización'}, 

  { path: "/quotations/print/:id", exact: false, component: QuotationsPrint, name: 'QuotationPrint', title: 'Impresión Nota de Cotización'}, 
  // Laboratorios

  { path: "/labCitec/:id", exact: false, component: LabCitecDetails, name: 'labCitecDetails', title: 'Edición de solicitud de Servicio'},

  { path: "/labCitec/:id/tests", exact: true, component: LabCitecDetails, name: 'labCitecDetails', title: 'Edición de solicitud de Servicio'},

  { path: "/labCitec/:id/reports", exact: true, component: LabCitecDetails, name: 'labCitecDetails', title: 'Edición de solicitud de Servicio'},
  
  // ¿Modificar el path?
  { path: "/labCitecScheduledTests", exact: false, component: LabCitecScheduledTests, name: 'labCitecScheduledTests', title: 'Calendario'},
  // ¿Modificar el path?
  { path: "/addInfoToTest/:id/:rowInfoLabTestViewId", exact: false, component: AddInfoToTest, name: 'addInfoToTest', title: 'Editar Detalle'},
  
  { path: "/labCitec",exact: false, component: LabCitec, name: 'labCitec', title: 'Solicitud de Servicio de Laboratorio Citec'}, 

  { path: "/labCitec/download-report",exact: false, component: ExcelReport, name: 'labCitecDownload', title: 'Descarga de Reporte de Laboratorio Citec'}, 

  { path: "/labmoviles",exact: false, component: LabCitec, name: 'labMoviles', title: 'Solicitud de Servicio de Laboratorio Móvil'}, 

  { path: "/labmoviles/download-report",exact: false, component: ExcelReport, name: 'labMovilesDownload', title: 'Descarga de Reporte de Laboratorio Móvil'}, 

  { path: "/notifications",exact: false, component: Notifications, name: 'notifications', title: 'Notificaciones'},

  { path: "/notifications/labTests",exact: false, component: LabTests, name: 'labTests', title: 'Ensayos'},
  
  { path: "/normLibrary",exact: false, component: NormLibrary, name: 'normLibrary', title: 'Biblioteca de Normas'}, 
  { path: "/normLibrary/PDF-Viewer/:file",exact: false, component: NormLibraryPDFViewer, name: 'normLibraryPDFViewer', title: 'Visualizador de Normas'}, 

  //Tres opciones añadidas
  { path: "/roi",exact: false, component: Roi, name: 'roi', title: 'ROI'},
  { path: "/roi/:id",exact: false, component: RoiSummary, name: 'roiSummary', title: 'Detalle de ROI'},
  { path: "/results",exact: false, component: Results, name: 'results', title: 'Resultados'},  
  { path: "/results/:id", exact: false, component: ResultsSummary, name: 'resultsDetail', title: 'Detalle de Resultados'},
  { path: "/process-notification/:id", exact: false, component: ProcessNotification, name: 'processNotification', title: 'Notificación de Validación de Procesos'},

  ...labRequestSampleRoutes,
  ...developmentViewRoutes,

  // this route should be at the end of all other routes
  { path: "/", exact: true, component: () => <Redirect to="/home" /> },
];

const authRoutes = [
  { path: "/logout", component: Logout },
  { path: "/login", component: Login },
  { path: "/register", component: Register },
]

export { authRoutes, userRoutes }
